import React, { useEffect, useState } from "react";
import { TVAStateService } from "../services/TVAStateService.js";
import "./TVACountryPicker.css"; // Import du fichier CSS séparé

export default function TVACountryPicker({ onClose, onSelect }) {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadStates = async () => {
      try {
        const service = new TVAStateService();
        const data = await service.getAllTVAStates();
        setStates(data);
      } catch (e) {
        console.error("Error loading TVA states", e);
      } finally {
        setLoading(false);
      }
    };

    loadStates();
  }, []);

  const handleSelect = () => {
    if (selectedState) {
      onSelect(selectedState);
    }
    onClose();
  };

  if (loading) {
    return (
      <div className="tva-picker-overlay">
        <div className="tva-picker-modal">
          <p>Chargement des états...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="tva-picker-overlay">
      <div className="tva-picker-modal">
        <h2 className="tva-picker-title">Sélection de l'État / Pays TVA</h2>

        <table className="tva-picker-table">
          <thead>
            <tr>
              <th></th>
              <th>Code</th>
              <th>Label / Pays</th>
            </tr>
          </thead>

          <tbody>
            {states.length === 0 ? (
              <tr>
                <td colSpan="3" style={{ textAlign: "center", padding: "16px", color: "#666" }}>
                  Aucun état trouvé
                </td>
              </tr>
            ) : (
              states.map((s) => (
                <tr 
                  key={s.id} 
                  className={`tva-picker-row ${selectedState?.id === s.id ? "selected" : ""}`}
                  onClick={() => setSelectedState(s)}
                >
                  <td>
                    <input
                      type="radio"
                      name="tvaStateSelection"
                      checked={selectedState?.id === s.id}
                      onChange={() => setSelectedState(s)}
                    />
                  </td>
                  <td>{s.code}</td>
                  <td>{s.label}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        <div className="tva-picker-actions">
          <button 
            className="tva-picker-btn"
            onClick={handleSelect} 
            disabled={!selectedState}
          >
            Sélectionner
          </button>

          <button 
            className="tva-picker-btn-secondary"
            onClick={onClose}
          >
            Annuler
          </button>
        </div>
      </div>
    </div>
  );
}